import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProductScreenshotComponent } from './product-screenshot.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [ProductScreenshotComponent],
  exports: [ProductScreenshotComponent],
})
export class ProductScreenshotModule {}
